import aimg1 from "../project-images/1.Glamoour/1a.png";
import aimg2 from "../project-images/1.Glamoour/1b.png";
import aimg3 from "../project-images/1.Glamoour/1c.png";
import aimg4 from "../project-images/1.Glamoour/1d.png";

import bimg1 from "../project-images/2.Top10Schools/2a.png";
import bimg2 from "../project-images/2.Top10Schools/2b.png";
import bimg3 from "../project-images/2.Top10Schools/2c.png";
import bimg4 from "../project-images/2.Top10Schools/2d.png";

import cimg1 from "../project-images/3.BlackJack/3a.png";
import cimg2 from "../project-images/3.BlackJack/3b.png";
import cimg3 from "../project-images/3.BlackJack/3c.png";
import cimg4 from "../project-images/3.BlackJack/3d.png";

import dimg1 from "../project-images/4.SmartAntiRagg/4a.png";
import dimg2 from "../project-images/4.SmartAntiRagg/4b.png";
import dimg3 from "../project-images/4.SmartAntiRagg/4c.png";
import dimg4 from "../project-images/4.SmartAntiRagg/4d.png";

import eimg1 from "../project-images/5.AnalogClock/5a.png";

import fimg1 from "../project-images/6.ReactSite/6a.png";
import fimg2 from "../project-images/6.ReactSite/6b.png";
import fimg3 from "../project-images/6.ReactSite/6c.png";
import fimg4 from "../project-images/6.ReactSite/6d.png";

import gimg1 from "../project-images/7.Authenticate/7a.png";
import gimg2 from "../project-images/7.Authenticate/7b.png";
import gimg3 from "../project-images/7.Authenticate/7c.png";
import gimg4 from "../project-images/7.Authenticate/7d.png";

import himg1 from "../project-images/8.CircleLink/8a.png";
import himg2 from "../project-images/8.CircleLink/8b.png";
import himg3 from "../project-images/8.CircleLink/8c.png";
import himg4 from "../project-images/8.CircleLink/8d.png";

import iimg1 from "../project-images/9.CatGenerator/9a.png";
import iimg2 from "../project-images/9.CatGenerator/9b.png";
import iimg3 from "../project-images/9.CatGenerator/9c.png";
import iimg4 from "../project-images/9.CatGenerator/9d.png";

import jimg1 from "../project-images/10.RockPaperScissor/10a.png";
import jimg2 from "../project-images/10.RockPaperScissor/10b.png";
import jimg3 from "../project-images/10.RockPaperScissor/10c.png";
import jimg4 from "../project-images/10.RockPaperScissor/10d.png";

import kimg1 from "../project-images/11.BestSeries/11a.png";
import kimg2 from "../project-images/11.BestSeries/11b.png";
import kimg3 from "../project-images/11.BestSeries/11c.png";
import kimg4 from "../project-images/11.BestSeries/11d.png";


const ProjectsData = [
    {
        text: "CircleLink",
        subText: "Real-time chat application built using Socket.io, Chakra UI and MERN. Includes user authentication, Group and one on one chat.",
        img1: himg1,
        img2: himg2,
        img3: himg3,
        img4: himg4,
        link: "https://github.com/mrvlsaf/CircleLink",
        popupText: "OUIPAN-Chat App",
    },
    {
        text: "Glamoour",
        subText: "A static website to showcase my photography skills. Built using HTML5 and CSS3 and Bootstrap.",
        img1: aimg1,
        img2: aimg2,
        img3: aimg3,
        img4: aimg4,
        link: "https://github.com/mrvlsaf/WebDev/tree/main/Glamoour",
        popupText: "Glamoour Website",
        visit: "https://laughing-agnesi-572c0e.netlify.app/"
    },
    // {
    //     text:"Top 10 Schools",
    //     subText:"A website I built for a school student is completely static using HTML/CSS.",
    //     img1: bimg1,
    //     img2: bimg2,
    //     img3: bimg3,
    //     img4: bimg4,
    //     link: "https://github.com/mrvlsaf/WebDev/tree/main/Top-10schools",
    //     popupText:"Top 10 Schools",
    //     visit: "https://compassionate-kilby-f0cb24.netlify.app/"
    // },
    {
        text: "BlackJack",
        subText: "BlackJack game built using ReactJs, modern hooks and Components. Try yourself and win against CPU. Best of Luck!",
        img1: cimg1,
        img2: cimg2,
        img3: cimg3,
        img4: cimg4,
        link: "https://github.com/mrvlsaf/WebDev/tree/main/JavaScript/BlackJack",
        popupText: "BlackJack",
        visit: "https://clever-carson-705aa0.netlify.app/"
    },
    {
        text: "Smart-AntiRagg",
        subText: "Hackathon Award-winning web app built using ReactJS and Bootstrap",
        img1: dimg1,
        img2: dimg2,
        img3: dimg4,
        img4: dimg4,
        link: "https://github.com/mrvlsaf/ReactJs/tree/main/Smart-AntiRagg",
        popupText: "website built for sharda hackathon",
    },
    // {
    //     text:"Analog Clock",
    //     subText:"One of my first projects while I was learning basics of Web Development.",
    //     img1: eimg1,
    //     img2: eimg1,
    //     img3: eimg1,
    //     img4: eimg1,
    //     link: "https://github.com/mrvlsaf/WebDev/tree/main/AnaClocky",
    //     popupText:"Analog Clock",
    //     visit: "https://epic-swirles-7599fa.netlify.app/"
    // },
    // {
    //     text:"React-Site",
    //     subText:"This is the first ever website I made using ReactJs. It's minimal but made me learn the concepts of components in React.",
    //     img1: fimg1,
    //     img2: fimg2,
    //     img3: fimg3,
    //     img4: fimg4,
    //     link: "https://github.com/mrvlsaf/ReactJs",
    //     popupText:"first ever react site",
    //     visit: ""
    // },
    // {
    //     text:"Authenticate",
    //     subText:"This is the authentication web app built in React. It has been made mostly using hooks and Firebase. It involves Login, SignUp, Forgot Password and Update profile features.",
    //     img1: gimg1,
    //     img2: gimg2,
    //     img3: gimg3,
    //     img4: gimg4,
    //     link: "https://github.com/mrvlsaf/ReactJs/tree/main/Authenticate",
    //     popupText:"authentication demo in react",
    // },
    // {
    //     text:"Cat-generator",
    //     subText:"Just a random cat generator built using JavaScript.",
    //     img1: iimg1,
    //     img2: iimg2,
    //     img3: iimg3,
    //     img4: iimg4,
    //     link: "https://github.com/mrvlsaf/WebDev/tree/main/JavaScript/Cat-generator",
    //     popupText:"Cat-generator",
    //     visit: "https://vibrant-dijkstra-82cc00.netlify.app/"
    // },
    // {
    //     text:"Rock-Paper-Scissor",
    //     subText:"The classic Rock-Paper-Scissor game built using Vanilla Javascript. Try your luck with the computer.",
    //     img1: jimg1,
    //     img2: jimg2,
    //     img3: jimg3,
    //     img4: jimg4,
    //     link: "https://github.com/mrvlsaf/WebDev/tree/main/JavaScript/Rock-Paper-Scissor",
    //     popupText:"Rock-Paper-Scissor",
    //     visit: "https://objective-shaw-007468.netlify.app/"
    // },
    // {
    //     text:"Best-Series",
    //     subText:"Basic Static website listing my all time favourite web-series.",
    //     img1: kimg1,
    //     img2: kimg2,
    //     img3: kimg3,
    //     img4: kimg4,
    //     link: "https://github.com/mrvlsaf/ReactJs",
    //     popupText:"Best Series of all time-TVD",
    // }
];

export default ProjectsData;